import { Subject } from 'helpers/store';
import { ALLY_FEATURES as ALLY_FEATURES_V1 } from 'constants/ally-features';
import { ALLY_FEATURES as ALLY_FEATURES_V2 } from 'constants-v2/ally-features';
import { configStore } from './config.store';

export interface ResetFeatureData {
  trigger: {
    feature: string;
    actionState: number;
  };
}

class AllyFeaturesStore {
  public resetFeature$ = new Subject<ResetFeatureData>();

  public get features() {
    return configStore.config$.lastValue?.isNewDesign
      ? Object.keys(ALLY_FEATURES_V2)
          .filter((key) => !ALLY_FEATURES_V2[key].isProfile)
          .reduce((res, key) => {
            res[key] = ALLY_FEATURES_V2[key];
            return res;
          }, {})
      : ALLY_FEATURES_V1;
  }

  public get profiles() {
    return Object.keys(ALLY_FEATURES_V2)
      .filter((key) => ALLY_FEATURES_V2[key].isProfile)
      .reduce((res, key) => {
        res[key] = ALLY_FEATURES_V2[key];
        return res;
      }, {});
  }
}

(window as any).allyFeaturesStore = new AllyFeaturesStore();

export const allyFeaturesStore = (window as any).allyFeaturesStore as AllyFeaturesStore;
